export const EVENT_MONITORING_TOKEN_KEY = "token";
export const EVENT_MONITORING_USER_KEY = "user";
export const EVENT_MONITORING_USER_ID_KEY = "userId";
export const EVENT_MONITORING_PROVIDER_KEY = "auth-provider";
export const EVENT_MONITORING_PROVIDER_VALUE = "azure-sso";

export const EVENT_COLLECT_TOKEN_KEY = "eventcollect-token";
export const EVENT_COLLECT_USER_KEY = "eventcollect-user";
export const EVENT_COLLECT_USER_ID_KEY = "eventcollect-userId";
export const EVENT_COLLECT_PROVIDER_KEY = "eventcollect-provider";
export const EVENT_COLLECT_PROVIDER_VALUE = "eventcollect-auth";
